// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__em+Zf","heading":"styles_heading__v5grF","poolValuesWrapper":"styles_poolValuesWrapper__V7Rk5"};